import { useState, useEffect } from 'react';
import { DatePicker, Form, Button, Divider, Row } from 'antd';
import './Sales.css';
import axios from 'axios';
import { Column } from '@ant-design/plots';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';

const { RangePicker } = DatePicker;

const rangeConfig = {
    rules: [
      {
        required: true,
        message: 'Please select time!',
      },
    ],
  };

const SalesByDate=()=>{
    const [form] = Form.useForm();

    const [dateRange, setDateRange] = useState({
        'SalesStartDate': 'YYYY-MM-DD',
        'SalesEndDate':'YYYY-MM-DD'
      })
    const [data, setData]= useState()
    const [trigger, setTrigger] = useState(false)
    // const [getTri, setGetTri] = useState(false)
    

      useEffect(()=>{
        let apiURL = `${FetchVariable.Heroku}/sales/get-sales-by-date`
        axios.post(apiURL, dateRange)
        .then(res=>{
            let data = res?.data
            let array=[]

            data.map((e)=>{
              return array?.push({SalesDate: e.SalesDate, SalesPrice:parseInt(e.SalesPrice)})
            })
            setData(array)
        })
      },[dateRange])


    const onFinish = (fieldsValue) => {
        const rangeValue = fieldsValue['range-picker'];
        const values = {
          'SalesStartDate': rangeValue[0]?.format('YYYY-MM-DD'),
          'SalesEndDate':rangeValue[1]?.format('YYYY-MM-DD')
        };
        setDateRange(values)
        setTrigger(true)
      };

      const ShowGraph = () => {
        if(trigger === true){
          return(
        <Column {...config} />
          )
        }else{
          return null
        }
      }

      const config = {
        data,
        xField: 'SalesDate',
        yField: 'SalesPrice',
        label: {
          position: 'middle',
          style: {
            fill: '#FFFFFF',
            opacity: 0.8,
          },
        },
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
        },
        meta: {
          type: {
            alias: 'Date',
          },
          sales: {
            alias: 'Sales',
          },
        },
      }


    return (
        <div>
            <Form 
                form={form}
                name="advanced_search"
                className="ant-advanced-search-form"
                onFinish={onFinish}
            >
              <Row>
                <Form.Item name="range-picker" label="Select Date Range" {...rangeConfig}>
                    <RangePicker 

                    />
                </Form.Item>

                <Form.Item
                wrapperCol={{
                    xs: {
                    span: 24,
                    offset: 0,
                    },
                    sm: {
                    span: 16,
                    offset: 8,
                    },
                }}
                >
                    <Button type="primary" htmlType="submit">
                        Search
                    </Button>
                </Form.Item>
                </Row>
            </Form>
                <Divider/>
                <ShowGraph />
        </div>


    )
}
export default SalesByDate